import React from 'react';
import Row from './row';

export default props => {
  let { documents, images, meta } = props;
  const typesMap = {};
  const indexesMap = {};
  if (meta && meta.documentTypes && meta.documentIndexes) {
    for (const type of meta.documentTypes) {
      typesMap[type.id] = type.description;
    }

    for (const documentIndex of meta.documentIndexes) {
      indexesMap[documentIndex.id] = documentIndex;
    }
  }
  return (
    <table className="table table-striped" style={{ fontSize: '0.85em' }}>
      <thead>
        <tr>
          <th />
          <th>Image</th>
          <th>Document Class</th>
          <th>Description</th>
          <th>Date Entered</th>
        </tr>
      </thead>
      <tbody>
        {documents.length > 0 &&
          documents.map((document, index) => {
            const thumb = images[document.id];
            return (
              <Row
                key={index}
                rowCount={index + 1}
                document={document}
                thumb={thumb}
                typesMap={typesMap}
                indexesMap={indexesMap}
              />
            );
          })}
      </tbody>
    </table>
  );
};
